/*----- Core -----*/
import React 					 from 'react'
import styled, { css } from 'styled-components'
import PropTypes       from 'prop-types'

/*----- Commons -----*/
import Montserrat from '../../commons/mixins/fonts/Montserrat'
import Color		  from '../../commons/Color'

/*----- Styles -----*/
const StyledSectionTitle = styled.h1`
	max-width: 720px;
	width: 100%;
	${ Montserrat( 30, 700, Color.grey )}
	line-height: 34px;
	margin-bottom: 32px;
	${props => props.invert && css`
		color: white;
  `}

`

/*----- Component -----*/
function PageTitle({ content, invert}) {
	return (
		<StyledSectionTitle className="page-title" invert={invert? 1 : 0}>{ content }</StyledSectionTitle>
	)
}

export default PageTitle

/*----- PropTypes -----*/
PageTitle.propTypes = {
  content: PropTypes.string.isRequired,
  invert:  PropTypes.bool
}
